import { Button, Card, Form, Input, Modal, Space, Typography } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { FileProperties } from "../../../../types/file.type";
import { generateFormRules } from "../../../../helpers/formRules";
import UploadInput from "../../../../components/form/UploadInput";
import { ReactComponent as UploadImage } from "../../../../assets/Icons/UploadBlogImage.svg";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import ImageItem from "./ImageItem";

export interface FormValuesUploadImage {
	id: string;
	file?: File | FileProperties | undefined;
	imageName: string;
	captionImage?: string | null;
}
interface IProps {
	onImage?: (images: FormValuesUploadImage[]) => void;
	value?: any;
	titleBlog?: string;
}
export default function UploadImageBlog({ onImage, value, titleBlog }: IProps) {
	const [open, setOpen] = useState(false);
	const [form] = Form.useForm<FormValuesUploadImage>();
	const [images, setImages] = useState<FormValuesUploadImage[]>([]);
	const [selectedImage, setSelectedImage] = useState<FormValuesUploadImage | undefined>(undefined);

	const doSubmit = async (values: FormValuesUploadImage) => {
		if (selectedImage) {
			const newDto = {
				id: selectedImage.id,
				imageName: values.imageName,
				captionImage: values.captionImage || null,
				file: values.file,
			};

			const newImages = images.map((img) => (img.id === selectedImage.id ? newDto : img));
			setImages(newImages);
		} else {
			const dto = {
				...values,
				id: Math.random().toString(16).slice(2),
			};

			setImages([...images, dto]);
		}
		setSelectedImage(undefined);
		setOpen(false);
		form.resetFields();
	};

	const doDelete = (id: string) => {
		const newImages = images.filter((img) => img.id !== id);

		setImages(newImages);
	};

	useEffect(() => {
		onImage?.(images);
	}, [images]);

	useEffect(() => {
		if (selectedImage) {
			form.setFieldsValue({
				file: selectedImage?.file,
				imageName: selectedImage?.imageName,
				captionImage: selectedImage?.captionImage,
			});
		}
	}, [selectedImage, open]);

	useEffect(() => {
		if (value) {
			setImages(value);
		}
	}, [value]);

	return (
		<div>
			<Space>
				{images.length > 0 &&
					images.map((image) => (
						<ImageBlogContainer>
							<ImageItem value={image.file} />

							<Space className="container-btn">
								<Button
									icon={<EditOutlined />}
									onClick={() => {
										setSelectedImage(image);
										setOpen(true);
									}}
								/>
								<Button
									danger={true}
									type="primary"
									icon={<DeleteOutlined />}
									onClick={() => doDelete(image.id)}
								/>
							</Space>
						</ImageBlogContainer>
					))}
				{images.length === 0 && (
					<CardUploadImage
						bordered={false}
						onClick={() => setOpen(true)}
					>
						<Space
							size={4}
							direction="vertical"
							style={{
								alignItems: "center",
								textAlign: "center",
							}}
						>
							<UploadImage />
							<Typography.Text
								style={{
									fontSize: 14,
									fontWeight: 500,
								}}
							>
								Add Image
							</Typography.Text>
							<Typography.Text
								style={{
									fontSize: 12,
								}}
								type="secondary"
							>
								Your images format should be .png and .jpg
							</Typography.Text>
						</Space>
					</CardUploadImage>
				)}
			</Space>

			<Modal
				destroyOnClose={true}
				open={open}
				onCancel={() => {
					setOpen(false);
				}}
				onOk={form.submit}
				width={520}
			>
				<Form
					form={form}
					preserve={false}
					layout="vertical"
					name="basic"
					autoComplete="off"
					onFinish={doSubmit}
					initialValues={{
						imageName: titleBlog ?? undefined,
					}}
				>
					<Form.Item
						name="file"
						rules={generateFormRules("Banner", ["required"])}
					>
						<UploadInput
							maxFileSize={10}
							allowedExtension={["jpg", "png"]}
							enableAutoResizeForImage={true}
						/>
					</Form.Item>
					<Form.Item
						name="imageName"
						label="Image Name"
					>
						<Input placeholder="Enter image name..." />
					</Form.Item>

					<Form.Item
						name="captionImage"
						label="Add Caption image (optional)"
					>
						<Input.TextArea
							rows={5}
							placeholder="Enter image caption..."
						/>
					</Form.Item>
				</Form>
			</Modal>
		</div>
	);
}

const CardUploadImage = styled(Card)`
	box-shadow: none;
	border: 1px dashed #d0d9df;
	border-radius: 8px;
	width: 190px;
	height: 170px;
	cursor: pointer;
	.ant-card-body {
		box-sizing: border-box;
		padding: 28px 20px;
	}

	&:hover {
		border-color: #00133b;
	}
`;

const ImageBlogContainer = styled.div`
	position: relative;

	.container-btn {
		position: absolute;
		bottom: 8px;
		right: 8px;
		z-index: 9;
	}
`;
